module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d72263b5e65bd03415f08f8b47faa4f.png";